/* ==========================================================================
   Dukier · Pinch-zoom inline en la galería de la ficha de producto (móvil)
   --------------------------------------------------------------------------
   Comportamiento (estilo Instagram):
   - Pellizcar amplía la foto ahí mismo, anclada a los dedos, con pan libre.
   - Si sueltas UN dedo, el zoom se mantiene y el dedo restante sigue
     moviendo la imagen; al soltar el ÚLTIMO dedo, rebote suave a su sitio.
   - Mientras dura el gesto (y el rebote), el scroll de la página queda
     bloqueado y el carrusel pausado.
   - Doble toque: zoom ×2.2 persistente; un dedo panea; doble toque vuelve.
   - Al deslizar en horizontal entre fotos, el scroll vertical de la página
     se bloquea (eje dominante al inicio del gesto, como Instagram).
   - En táctil se oculta la lupa de la esquina (en escritorio sigue igual).
   - Sin dependencias. Se integra con Flickity pausando su drag durante el zoom.
   Creado 24/08/2026, revisado tras feedback de David (mismo día).
   Para desinstalar: borrar este asset y su include en layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var isTouch = 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0;
  if (!isTouch) return;

  var WRAP_SEL = '.product__main-photos .product-main-slide .image-wrap';
  var SLIDER_SEL = '.product__main-photos .flickity-enabled';
  var ZOOM_BTN_SEL = '.product__photo-zoom';

  var MAX_SCALE = 4;        // tope de pinch
  var STAY_SCALE = 2.2;     // zoom del doble toque
  var EXIT_SCALE = 1.06;    // por debajo de esto al soltar, se sale del zoom
  var DBL_MS = 300;         // ventana del doble toque
  var DBL_DIST = 40;        // distancia máx. entre los dos toques
  var TAP_MOVE = 12;        // movimiento máx. para contar como toque
  var ANIM_MS = 240;
  var SWIPE_DECIDE = 8;     // px de movimiento para decidir el eje del gesto
  var SWIPE_GRACE = 350;    // ms de retención del scroll tras soltar un swipe

  /* ---- estilos propios (incluye ocultar la lupa en táctil) ---- */
  var style = document.createElement('style');
  style.textContent =
    '@media (pointer: coarse){' +
      '.product__main-photos .product-main-slide .image-wrap{overflow:hidden;}' +
      '.product__main-photos .product__photo-zoom{display:none !important;}' +
    '}' +
    '.dz-anim{transition:transform ' + ANIM_MS + 'ms cubic-bezier(.25,.1,.25,1) !important;}' +
    '.dz-target{transform-origin:0 0;}';
  document.head.appendChild(style);

  /* ---- estado ---- */
  var st = null;                       // sesión de zoom activa (una imagen a la vez)
  var lastTap = { t: 0, x: 0, y: 0 };  // para el doble toque
  var tapTrack = null;                 // seguimiento del toque single actual
  var lastGestureEnd = 0;
  var savedDraggable = null;
  var swipe = null;                    // gesto de un dedo sobre la galería (eje por decidir)
  var swipeHold = { until: 0, y: 0 };  // retención post-swipe (frena inercia residual)

  function getTarget(wrap) {
    var el = wrap.querySelector('image-element, .featuredImgCont');
    if (el && getComputedStyle(el).display === 'inline') el = null; // inline no transforma
    if (!el) el = wrap.querySelector('img');
    return el || null;
  }

  function getFlickity() {
    var el = document.querySelector(SLIDER_SEL);
    if (!el || !window.Flickity) return null;
    return window.Flickity.data(el) || null;
  }

  function setFlickityDrag(enabled) {
    var flkty = getFlickity();
    if (!flkty) return;
    if (!enabled) {
      if (savedDraggable === null) savedDraggable = flkty.options.draggable;
      flkty.options.draggable = false;
      flkty.updateDraggable();
    } else if (savedDraggable !== null) {
      flkty.options.draggable = savedDraggable;
      flkty.updateDraggable();
      savedDraggable = null;
    }
  }

  function bindSlideChangeReset() {
    var el = document.querySelector(SLIDER_SEL);
    if (!el || el.dataset.dzBound) return;
    var flkty = getFlickity();
    if (!flkty) return;
    el.dataset.dzBound = '1';
    flkty.on('change', function () { if (st) resetZoom(st, false); });
  }

  function pswpOpen() {
    var p = document.querySelector('.pswp');
    return !!(p && p.className.indexOf('pswp--open') !== -1);
  }

  function upgradeImage(wrap) {
    if (wrap.dataset.dzHiRes) return;
    wrap.dataset.dzHiRes = '1';
    var img = wrap.querySelector('img[data-photoswipe-src]');
    if (!img) return;
    var hi = img.getAttribute('data-photoswipe-src');
    if (!hi) return;
    var pre = new Image();
    pre.onload = function () {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = hi;
    };
    pre.src = hi;
  }

  function applyTransform(s) {
    s.target.style.transform =
      'translate3d(' + s.tx + 'px,' + s.ty + 'px,0) scale(' + s.scale + ')';
  }

  function clampPan(s) {
    // La imagen llena el wrap: que el contenido siempre cubra el marco
    var minX = s.w * (1 - s.scale), minY = s.h * (1 - s.scale);
    if (s.tx > 0) s.tx = 0; else if (s.tx < minX) s.tx = minX;
    if (s.ty > 0) s.ty = 0; else if (s.ty < minY) s.ty = minY;
  }

  function animate(s, done) {
    s.target.classList.add('dz-anim');
    applyTransform(s);
    clearTimeout(s.animT);
    s.animT = setTimeout(function () {
      s.target.classList.remove('dz-anim');
      if (done) done();
    }, ANIM_MS + 30);
  }

  function newState(wrap) {
    var target = getTarget(wrap);
    if (!target) return null;
    return {
      wrap: wrap, target: target,
      w: wrap.clientWidth, h: wrap.clientHeight,
      scale: 1, tx: 0, ty: 0,
      sticky: false,        // true = zoom persistente (doble toque)
      springing: false,     // true durante la animación de vuelta
      lockY: 0,             // scroll de página bloqueado en este valor
      pinch: null, pan: null, animT: null
    };
  }

  // Prepara el entorno de zoom; también "revive" un estado en plena
  // animación de vuelta (cancela el timer que lo iba a limpiar).
  function enterZoomEnv(s) {
    clearTimeout(s.animT);
    s.springing = false;
    s.target.classList.remove('dz-anim');
    s.target.classList.add('dz-target');
    s.wrap.style.touchAction = 'none';
    s.lockY = window.scrollY;
    setFlickityDrag(false);
    bindSlideChangeReset();
    upgradeImage(s.wrap);
  }

  function resetZoom(s, animated) {
    s.scale = 1; s.tx = 0; s.ty = 0; s.sticky = false; s.pinch = null; s.pan = null;
    if (animated) {
      s.springing = true;
      animate(s, function () { finishReset(s); });
    } else {
      clearTimeout(s.animT);
      s.target.classList.remove('dz-anim');
      applyTransform(s);
      finishReset(s);
    }
  }

  function finishReset(s) {
    s.springing = false;
    s.target.style.transform = '';
    s.target.classList.remove('dz-target');
    s.wrap.style.touchAction = '';
    setFlickityDrag(true);
    if (st === s) st = null;
  }

  function localPoint(s, touch) {
    var r = s.wrap.getBoundingClientRect();
    return { x: touch.clientX - r.left, y: touch.clientY - r.top };
  }

  function dist(a, b) {
    var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy) || 1;
  }

  /* ---- bloqueo de scroll de página durante gestos ---- */
  function scrollLockActive() {
    return !!(st && (st.pinch || st.pan || st.springing));
  }
  function swipeLockEngaged() {
    return !!(swipe && swipe.decided && swipe.horizontal);
  }
  function holdScroll() {
    if (scrollLockActive()) {
      if (window.scrollY !== st.lockY) window.scrollTo(0, st.lockY);
      return;
    }
    if (swipeLockEngaged()) {
      if (window.scrollY !== swipe.lockY) window.scrollTo(0, swipe.lockY);
      return;
    }
    if (Date.now() < swipeHold.until && window.scrollY !== swipeHold.y) {
      window.scrollTo(0, swipeHold.y);
    }
  }
  window.addEventListener('scroll', holdScroll, { passive: true });

  /* ---------------- handlers ---------------- */

  function onTouchStart(evt) {
    if (pswpOpen()) return;
    swipeHold.until = 0; // tocar de nuevo libera la retención post-swipe

    if (evt.touches.length === 1) {
      var t = evt.touches[0];
      tapTrack = { x: t.clientX, y: t.clientY, moved: false };
    } else {
      tapTrack = null; // con más de un dedo ya no es un toque
      swipe = null;
    }

    var wrap = evt.target && evt.target.closest ? evt.target.closest(WRAP_SEL) : null;

    // Un dedo sobre una imagen con zoom persistente -> empezar pan
    if (wrap && evt.touches.length === 1 && st && st.sticky && st.wrap === wrap) {
      var p = evt.touches[0];
      st.pan = { x: p.clientX, y: p.clientY, moved: false };
      st.lockY = window.scrollY;
      clearTimeout(st.animT);
      st.target.classList.remove('dz-anim');
      return;
    }

    // Dos dedos sobre una imagen -> empezar pinch (o reanudarlo)
    if (wrap && evt.touches.length >= 2) {
      if (st && st.wrap !== wrap) resetZoom(st, false);
      if (!st) st = newState(wrap);
      if (!st) return;
      evt.preventDefault();
      enterZoomEnv(st);
      st.pan = null;
      var t0 = evt.touches[0], t1 = evt.touches[1];
      var m = { clientX: (t0.clientX + t1.clientX) / 2, clientY: (t0.clientY + t1.clientY) / 2 };
      st.pinch = {
        startDist: dist(t0, t1),
        startScale: st.scale,
        startTx: st.tx, startTy: st.ty,
        startMid: localPoint(st, m)
      };
      return;
    }

    // Un dedo sobre la galería (sin zoom activo): vigilar el eje del gesto
    // para bloquear el scroll vertical si el swipe resulta horizontal
    if (evt.touches.length === 1 && !(st && (st.sticky || st.pinch || st.pan))) {
      var slider = evt.target && evt.target.closest
        ? evt.target.closest('.product__main-photos .product-slideshow')
        : null;
      var ts = evt.touches[0];
      swipe = slider
        ? { x0: ts.clientX, y0: ts.clientY, lockY: window.scrollY, decided: false, horizontal: false }
        : null;
    }
  }

  function onTouchMove(evt) {
    if (tapTrack && evt.touches.length === 1) {
      var tt = evt.touches[0];
      if (Math.abs(tt.clientX - tapTrack.x) > TAP_MOVE ||
          Math.abs(tt.clientY - tapTrack.y) > TAP_MOVE) {
        tapTrack.moved = true;
      }
    }

    // Swipe de un dedo sobre la galería: decidir eje y, si es horizontal,
    // mantener la página quieta mientras se cambia de foto
    if (swipe && evt.touches.length === 1 && !(st && (st.pinch || st.pan))) {
      var sw = evt.touches[0];
      if (!swipe.decided) {
        var adx = Math.abs(sw.clientX - swipe.x0);
        var ady = Math.abs(sw.clientY - swipe.y0);
        if (Math.max(adx, ady) > SWIPE_DECIDE) {
          if (adx > ady) {
            swipe.decided = true;
            swipe.horizontal = true;
          } else {
            swipe = null; // scroll vertical normal: no intervenir
          }
        }
      }
      if (swipe && swipe.horizontal) {
        if (evt.cancelable) evt.preventDefault();
        holdScroll();
      }
    }

    if (!st) return;

    if (st.pinch && evt.touches.length >= 2) {
      if (evt.cancelable) evt.preventDefault();
      var t0 = evt.touches[0], t1 = evt.touches[1];
      var m = { clientX: (t0.clientX + t1.clientX) / 2, clientY: (t0.clientY + t1.clientY) / 2 };
      var mid = localPoint(st, m);
      var p = st.pinch;
      var raw = p.startScale * (dist(t0, t1) / p.startDist);
      var scale = Math.min(MAX_SCALE, Math.max(1, raw));
      // Punto del contenido que había bajo los dedos al empezar: anclar ahí
      var cx = (p.startMid.x - p.startTx) / p.startScale;
      var cy = (p.startMid.y - p.startTy) / p.startScale;
      st.scale = scale;
      st.tx = mid.x - cx * scale;
      st.ty = mid.y - cy * scale;
      applyTransform(st);
      holdScroll();
      return;
    }

    if (st.pan && evt.touches.length === 1) {
      if (evt.cancelable) evt.preventDefault();
      var t = evt.touches[0];
      if (!st.pan.moved &&
          (Math.abs(t.clientX - st.pan.x) > 3 || Math.abs(t.clientY - st.pan.y) > 3)) {
        st.pan.moved = true;
      }
      st.tx += t.clientX - st.pan.x;
      st.ty += t.clientY - st.pan.y;
      st.pan.x = t.clientX;
      st.pan.y = t.clientY;
      if (st.sticky) clampPan(st); // en modo "peek" el pan es libre (todo rebota luego)
      applyTransform(st);
      holdScroll();
    }
  }

  function endZoomSession() {
    // Soltados todos los dedos: decidir si se queda (sticky) o rebota
    lastGestureEnd = Date.now();
    lastTap.t = 0;
    if (st.sticky && st.scale >= EXIT_SCALE) {
      clampPan(st);
      animate(st);
    } else {
      resetZoom(st, true); // estilo Instagram: rebote de vuelta
    }
  }

  function onTouchEnd(evt) {
    // --- fin de swipe sobre la galería ---
    if (swipe && evt.touches.length === 0) {
      if (swipeLockEngaged()) {
        swipeHold.until = Date.now() + SWIPE_GRACE; // frenar inercia residual
        swipeHold.y = swipe.lockY;
      }
      swipe = null;
    }

    // --- pinch: se levanta un dedo pero queda otro -> mantener zoom y panear ---
    if (st && st.pinch && evt.touches.length === 1) {
      if (evt.cancelable) evt.preventDefault();
      st.pinch = null;
      var rest = evt.touches[0];
      st.pan = { x: rest.clientX, y: rest.clientY, moved: true };
      lastTap.t = 0;
      return;
    }

    // --- pinch: se sueltan los dos dedos a la vez ---
    if (st && st.pinch && evt.touches.length === 0) {
      if (evt.cancelable) evt.preventDefault();
      st.pinch = null;
      endZoomSession();
      return;
    }

    // --- fin de pan (último dedo fuera) ---
    if (st && st.pan && evt.touches.length === 0) {
      var panned = st.pan.moved;
      st.pan = null;
      if (!st.sticky) {
        if (evt.cancelable) evt.preventDefault();
        endZoomSession(); // venía de un pinch: rebote al soltar el último dedo
        return;
      }
      if (panned) { lastGestureEnd = Date.now(); lastTap.t = 0; return; }
      // sticky sin movimiento: puede ser un toque (sigue abajo, doble toque)
    }

    // --- detección de doble toque ---
    if (evt.touches.length !== 0 || evt.changedTouches.length !== 1) return;
    if (!tapTrack || tapTrack.moved) { lastTap.t = 0; return; }
    if (Date.now() - lastGestureEnd < 350) return;
    if (pswpOpen()) return;
    var touch = evt.changedTouches[0];
    var wrap = evt.target && evt.target.closest ? evt.target.closest(WRAP_SEL) : null;
    if (!wrap) { lastTap.t = 0; return; }
    if (evt.target.closest(ZOOM_BTN_SEL)) { lastTap.t = 0; return; }

    var now = Date.now();
    var isDouble = (now - lastTap.t) < DBL_MS &&
      Math.abs(touch.clientX - lastTap.x) < DBL_DIST &&
      Math.abs(touch.clientY - lastTap.y) < DBL_DIST;

    if (!isDouble) {
      lastTap = { t: now, x: touch.clientX, y: touch.clientY };
      return;
    }

    lastTap.t = 0;
    if (evt.cancelable) evt.preventDefault(); // sin zoom de página ni click fantasma

    if (st && st.sticky && st.wrap === wrap) {
      resetZoom(st, true);              // doble toque estando ampliado -> volver
      return;
    }

    // doble toque desde reposo -> ampliar anclado al punto tocado
    if (st && st.wrap !== wrap) resetZoom(st, false);
    if (!st) st = newState(wrap);
    if (!st) return;
    enterZoomEnv(st);
    var pt = localPoint(st, touch);
    st.scale = STAY_SCALE;
    st.tx = pt.x * (1 - STAY_SCALE);
    st.ty = pt.y * (1 - STAY_SCALE);
    clampPan(st);
    st.sticky = true;
    animate(st);
  }

  function onTouchCancel() {
    tapTrack = null;
    swipe = null;
    if (!st) return;
    st.pinch = null;
    st.pan = null;
    if (!st.sticky) resetZoom(st, true);
  }

  document.addEventListener('touchstart', onTouchStart, { passive: false, capture: true });
  document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
  document.addEventListener('touchend', onTouchEnd, { passive: false, capture: true });
  document.addEventListener('touchcancel', onTouchCancel, { passive: true, capture: true });

  // Editor de temas: si se recarga la sección, soltar cualquier estado
  document.addEventListener('shopify:section:load', function () {
    if (st) resetZoom(st, false);
  });
})();
